import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { SharedModule } from 'eddydata-lib';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { ConvenioLstComponent } from './convenio-lst/convenio-lst.component';
import { ConvenioShwComponent } from './convenio-shw/convenio-shw.component';
import { ConvenioRoutingModule } from './convenio-routing.module';
import { ConvenioFrmComponent } from './convenio-frm/convenio-frm.component';
import { ConvenioPrestacaoComponent } from './convenio-prestacao/convenio-prestacao.component';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConvenioComissaoComponent } from './convenio-comissao/convenio-comissao.component';
import { ConvenioHistoricoComponent } from './convenio-historico/convenio-historico.component';
import { ConvenioAditamentoComponent } from './convenio-aditamento/convenio-aditamento.component';
import { ConvenioAditamentoDlgComponent } from './convenio-aditamento-dlg/convenio-aditamento-dlg.component';
import { ConvenioPrestacaoDlgComponent } from './convenio-prestacao-dlg/convenio-prestacao-dlg.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@NgModule({
  declarations: [
    ConvenioLstComponent,
    ConvenioShwComponent,
    ConvenioFrmComponent,
    ConvenioPrestacaoComponent,
    ConvenioPrestacaoDlgComponent,
    ConvenioHistoricoComponent,
    ConvenioAditamentoComponent,
    ConvenioAditamentoDlgComponent,
    ConvenioComissaoComponent
  ],
  imports: [
    CommonModule,
    ConvenioRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    ConfirmDialogModule,
    IMaskModule,
    ToastModule
  ],
  providers: [ConfirmationService]
})
export class ConvenioModule { }
